// extracted by mini-css-extract-plugin
export default {"container":"meeting_container__EliGo"};